export const DESTINATION_ACCOUNT_ID_PARAM_NAME = "account";
export const ACCOUNT_REDIRECT_EMAIL_PARAM_NAME = "email";
export const ACCOUNT_REDIRECT_ID_PARAM_NAME = "accountId";

export const UTM_CAMPAIGN = "utm_campaign";
export const UTM_SOURCE = "utm_source";
export const UTM_MEDIUM = "utm_medium";
export const UTM_TYPE = "utm_type";
export const ORIGIN_WEB = "WEB";
